import { provideTaiga } from "@taiga-ui/core";
import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  withComponentInputBinding,
  withRouterConfig,
} from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideApi } from '../../generated-api';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { loadingInterceptor } from './shared/services/loading.interceptor';
import { authRedirectInterceptor } from './shared/interceptors/auth-redirect.interceptor';
import { sessionHttpInterceptor } from './shared/interceptors/session-http.interceptor';
import { networkConnectivityInterceptor } from './shared/interceptors/network-connectivity.interceptor';
import { ActiveInterviewRecordingService } from './shared/services/active-interview-recording.service';
import { PosthogService } from './shared/services/posthog.service';
import { PosthogErrorHandler } from './shared/services/posthog-error.handler';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: PosthogErrorHandler },
    provideAnimations(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({
        paramsInheritanceStrategy: 'always',
      })
    ),
    provideHttpClient(
      withInterceptors([
        loadingInterceptor,
        authRedirectInterceptor,
        sessionHttpInterceptor,
        networkConnectivityInterceptor,
      ])
    ),
    provideApi({
      basePath: environment.baseApiUrl,
      withCredentials: true,
    }),
    provideTaiga(),
    provideAppInitializer(() => {
      inject(PosthogService);
      inject(ActiveInterviewRecordingService);
    }),
  ],
};
